// extracted by mini-css-extract-plugin
module.exports =  {"codeContainer":"Registrations-module_codeContainer__oKVhskAfL_gXS2F0CqTH"};